import React, { Fragment } from 'react';

export default class PageBtn extends React.Component{
  constructor(props){
    super(props);
    this.state={
      hoverStyle:null,
    }
  }

  hover =()=>{
    
    this.setState({ 
      hoverStyle : { 
        backgroundColor: "#fff", 
        border: "2px solid #000", 
        color:"#000" 
      }
    })
  
  }
  // ______________________________________________________________________________

  
  render(){
    const { checkPage, disabled  } = this.props
    const { hoverStyle } = this.state

    let btn_label = null
    let btn_color = null
    let btn_fcolor = null

    if( !checkPage ){
      btn_label  = "確認ページへ"
      btn_color  = "#8bc34a"
      btn_fcolor = "#000"
    }else{
      btn_label = "上記内容で登録する"
      btn_color = "#2296F3"
      btn_fcolor = "#fff"
    }
    // ______________________________________________________________________________


    const btn_style = {
      marginBottom:16,
      height: 35,
      padding:"0px 25px",
      fontWeight: "bold",
      fontSize: 14,
      borderRadius: 20,
      boxShadow:" 2px 2px 2px #aaa",
      cursor: "pointer",
      borderStyle:"solid",
      borderWidth:"2px",
      border:btn_color,
      color: btn_fcolor,
      backgroundColor: btn_color,
      transition:"0.2s",
      boxSizing:"border-box",
    }
    // ______________________________________________________________________________
    
    return(
      <button 
        style        = { Object.assign({}, btn_style, hoverStyle ) }
        onClick      = { this.props.onClick } 
        onMouseOver  = { this.hover }
        onMouseLeave = { () => this.setState({ hoverStyle : null }) }
        onFocus      = { this.hover }
        onBlur       = { () => this.setState({ hoverStyle : null }) }
        disabled     = {disabled}
      >
        {btn_label}
      </button>
    )
  }
}
